export default __webpack_public_path__ + "static/media/MarcaDagua2.fbfaf244.png";